export const removeEmptyKeys = <T>(data: T) => {
  const isObject = typeof data === 'object' && data !== null

  const asArr = isObject ? Object.entries(data) : []

  const filtered = asArr.filter(([, value]) => Boolean(value))

  return Object.fromEntries(filtered) as T
}
